import { Tooltip as MuiTooltip, TooltipProps } from "@mui/material";
import { forwardRef } from "react";

type Props = TooltipProps;

export const Tooltip = forwardRef<HTMLDivElement, Props>((props, ref) => <MuiTooltip {...props} ref={ref} />);
Tooltip.displayName = "Tooltip";
